import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/apiClient";

// Query Keys
export const practiceKeys = {
  all: ["practices"],
  accessible: () => ["practices", "accessible"],
  allForPatients: () => ["practices", "all"],
};

// Get All Practices Hook - for patients to select which practice to book with
export const useAllPractices = () => {
  return useQuery({
    queryKey: practiceKeys.allForPatients(),
    queryFn: async () => {
      const response = await apiClient.get("/api/permissions/practices/all");
      return response.practices || [];
    },
    staleTime: 30 * 60 * 1000, // 30 minutes - practices don't change often
  });
};

// Get Accessible Practices Hook - for doctors/practice owners (existing functionality)
export const useAccessiblePractices = () => {
  return useQuery({
    queryKey: practiceKeys.accessible(),
    queryFn: async () => {
      const response = await apiClient.get("/api/permissions/practices");
      return response.accessiblePractices || [];
    },
    staleTime: 30 * 60 * 1000, // 30 minutes - practices don't change often
  });
};